export const SPORTS = [
  { key: 'nfl', label: 'NFL', icon: '🏈', espnSport: 'football', espnLeague: 'nfl', season: [9, 10, 11, 12, 1, 2] },
  { key: 'nba', label: 'NBA', icon: '🏀', espnSport: 'basketball', espnLeague: 'nba', season: [10, 11, 12, 1, 2, 3, 4, 5, 6] },
  { key: 'mlb', label: 'MLB', icon: '⚾', espnSport: 'baseball', espnLeague: 'mlb', season: [3, 4, 5, 6, 7, 8, 9, 10] },
  { key: 'nhl', label: 'NHL', icon: '🏒', espnSport: 'hockey', espnLeague: 'nhl', season: [10, 11, 12, 1, 2, 3, 4, 5, 6] },
  { key: 'epl', label: 'EPL', icon: '⚽', espnSport: 'soccer', espnLeague: 'eng.1', season: [8, 9, 10, 11, 12, 1, 2, 3, 4, 5] },
  { key: 'mls', label: 'MLS', icon: '⚽', espnSport: 'soccer', espnLeague: 'usa.1', season: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  { key: 'ucl', label: 'UCL', icon: '⚽', espnSport: 'soccer', espnLeague: 'uefa.champions', season: [9, 10, 11, 12, 1, 2, 3, 4, 5] },
];

export const SOCCER_SPORTS = ['epl', 'mls', 'ucl'];

/** Sports that support player props */
export const PROPS_SPORTS = ['nba'];

/** Player prop types we support */
export const PROP_TYPES = {
  points: { label: 'Points', short: 'PTS' },
  rebounds: { label: 'Rebounds', short: 'REB' },
  assists: { label: 'Assists', short: 'AST' },
  threePointers: { label: '3-Pointers Made', short: '3PT' },
  pts_reb_ast: { label: 'Pts + Reb + Ast', short: 'PRA' },
};

/** Format a player prop selection for display */
export function formatPropSelection(leg) {
  const typeLabel = PROP_TYPES[leg.propType]?.short || leg.propType;
  const dir = leg.selection === 'over' ? 'Over' : 'Under';
  return `${leg.athleteName} ${dir} ${leg.point} ${typeLabel}`;
}

export const BET_LIMITS = {
  MIN_BET: 1,
  MAX_PARLAY_LEGS: 10,
  BETTING_CLOSE_MINUTES: 60,
};

/** Convert decimal odds to American display string */
export function decimalToAmerican(decimal) {
  if (!decimal || decimal <= 1) return '-';
  if (decimal >= 2) {
    return `+${Math.round((decimal - 1) * 100)}`;
  }
  return `${Math.round(-100 / (decimal - 1))}`;
}

/** Convert American odds string to decimal */
export function americanToDecimal(american) {
  const num = parseInt(american, 10);
  if (isNaN(num)) return null;
  if (num > 0) return 1 + num / 100;
  return 1 + 100 / Math.abs(num);
}

/** Format potential payout for display */
export function formatPayout(amount) {
  if (amount >= 1000000) return `${(amount / 1000000).toFixed(2)}M`;
  if (amount >= 1000) return `${(amount / 1000).toFixed(1)}K`;
  return amount.toFixed(2);
}

/** Get sports that are currently in season */
export function getInSeasonSports(month) {
  const m = month || new Date().getMonth() + 1;
  return SPORTS.filter(s => s.season.includes(m));
}

/** Check if a sport supports draws (soccer) */
export function sportHasDraws(sportKey) {
  return SOCCER_SPORTS.includes(sportKey);
}

/** Format a game start time for display */
export function formatGameTime(commenceTime) {
  const d = new Date(commenceTime);
  const now = new Date();
  const isToday = d.toDateString() === now.toDateString();
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const isTomorrow = d.toDateString() === tomorrow.toDateString();

  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

  if (isToday) return `Today ${time}`;
  if (isTomorrow) return `Tomorrow ${time}`;
  return `${d.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${time}`;
}

/** Format a date header for grouping games */
export function formatDateHeader(commenceTime) {
  const d = new Date(commenceTime);
  const now = new Date();
  const isToday = d.toDateString() === now.toDateString();
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const isTomorrow = d.toDateString() === tomorrow.toDateString();

  if (isToday) return 'Today';
  if (isTomorrow) return 'Tomorrow';
  return d.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric' });
}

/** Build ESPN scoreboard URL for a sport */
export function getEspnScoreboardUrl(sport) {
  return `https://site.api.espn.com/apis/site/v2/sports/${sport.espnSport}/${sport.espnLeague}/scoreboard`;
}
